export default "__VITE_ASSET__69j5HnUOXubdwuyTXmrjEw__"